/**
 * TASKS-GENERATE
 * Modal giving action plan's tasks ideas, using GPT
 */

import Modal from "@/components/modal"
import { v4 as uuid } from "uuid"
import { WithTranslation, withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Topic } from "@/redux/topic.types"
import { useState } from "react"
import { Session } from "@/redux/_session.types"
import { ActionPlan, ActionPlanState, ActionPlanTask } from "@/redux/action-plan.types"
import TasksGeneratorWidget, { Idea } from "@/widgets/tasks-generator.widget"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import Space from "@/components/space"
import { store } from ".."
import { actionPlanActivate, actionPlanEdit, actionPlanUpdate } from "@/redux/action-plan.actions"
import { User } from "@/redux/user.types"
import { SurveyState } from "@/redux/survey.types"

interface StateProps {
  _session: Session
  actionPlan: ActionPlanState
  survey: SurveyState
}

interface OwnProps {
  selectedTopic: Topic
  onClose?: Function
}

type Props = StateProps & OwnProps & WithTranslation

function TasksGenerateModal(props: Props) {
  const { t } = props

  const [selectedIdeas, setSelectedIdeas] = useState<Idea[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  async function next() {
    if (selectedIdeas.length > 0) {
      const currentDate: Date = new Date()
      const newTasks: ActionPlanTask[] = [
        ...props.actionPlan.active.tasks,
        ...selectedIdeas.map(
          (idea: Idea) =>
            new ActionPlanTask({
              createdAt: currentDate,
              createdBy: "openAi",
              id: uuid(),
              title: idea.title,
              text: idea.text,
              topicAid: props.selectedTopic.aid
            })
        )
      ]

      //Create new action plan
      if (props.actionPlan.active.SurveyId !== props.survey.active.id) {
        const actionPlan = new ActionPlan({
          id: uuid(),
          User: new User({ id: props._session.userId }),
          UserId: props._session.userId,
          status: "draft",
          priority: t("tasks_name_survey", { name: props.survey.active.name }),
          tasks: newTasks,
          SurveyId: props.survey.active.id
        })

        store.dispatch(actionPlanActivate(actionPlan))
        store.dispatch(actionPlanUpdate(actionPlan, false))
      } else {
        //Update action plan and tasks
        store.dispatch(actionPlanEdit("tasks", newTasks, false))
        store.dispatch(actionPlanUpdate(new ActionPlan({ ...props.actionPlan.active, tasks: newTasks }), false))
      }

      close()
    } else {
      close()
    }
  }

  function close() {
    if (props.onClose) {
      props.onClose()
    }
  }

  function getActionOnNext(): Function | undefined {
    if (selectedIdeas.length > 0) {
      return next
    } else {
      return undefined
    }
  }

  function getOwlText(): string {
    if (isLoading) {
      return t("tasks_generating")
    } else {
      return t("tasks_generated", { topic: props.selectedTopic.label.toLowerCase() })
    }
  }

  return (
    <Modal disableClickOutside disableKeyEvents isLarge onNext={getActionOnNext()} isCloseButtonVisible onClose={close}>
      <>
        <div className="flex rel">
          <div style={{ width: 600 }}>
            <div
              className="rel"
              style={{
                height: 100,
                fontSize: 14,
                background: "#C8C8C8",
                clipPath: "polygon(0% 0%, 90% 0%, 90% 50%, 100% 70%, 90% 90%, 90% 100%, 0 100%)"
              }}>
              <div
                className="abs flex flex-dcol"
                style={{
                  position: "absolute",
                  top: 1,
                  left: 1,
                  width: 598,
                  height: 98,
                  background: "white",
                  clipPath: "polygon(0% 0%, 90% 0%, 90% 50%, 100% 70%, 90% 90%, 90% 100%, 0 100%)"
                }}>
                <Space />

                <div
                  className="grey-t medgrey-b"
                  style={{
                    padding: "20px 90px 20px 30px",
                    textAlign: "center"
                  }}>
                  <b>{getOwlText()}</b>
                </div>

                <Space />
              </div>
            </div>
          </div>

          <Space />

          <img
            className="abs"
            src={require("@/assets/assistant/owl_female.png")}
            alt={"owl assistant"}
            width={130}
            style={{
              objectFit: "contain",
              transform: "scaleX(-1)",
              right: 10
            }}
          />
        </div>

        {isLoading && (
          <div className="rel height-100">
            <div className="abs" style={{ left: "40%", marginTop: 30 }}>
              <FontAwesomeIcon icon={faCircleNotch} className="grey-t" spin size={"2x"} />
            </div>
          </div>
        )}

        <TasksGeneratorWidget
          onSelect={(ideas: Idea[]) => setSelectedIdeas(ideas)}
          selectedTopic={props.selectedTopic}
          onStatusUpdate={(loading: boolean) => setIsLoading(loading)}
        />
      </>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  actionPlan: state.actionPlan,
  survey: state.survey
})

export default connect(mapStateToProps)(withTranslation()(TasksGenerateModal))
